import { DialogContext } from "@ui/components/dialog/dialog-provider";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router";

export const CloseDialogHandler = (): JSX.Element | null => {
	const location = useLocation();
	const dialogContext = useContext(DialogContext);

	useEffect(() => {
		dialogContext?.closeAll();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	return null;
};
